import { getAccessTokenV2 } from '../../utils/auth/session-storage';
import React from 'react';
import { Navigate } from 'react-router-dom';

export const LoginSuccessRoute: React.FC = () => {
  const accessTokenV2 = getAccessTokenV2();

  if (!accessTokenV2) {
    // Redirect to login if not authenticated
    return <Navigate to="/future/auth/login" replace />;
  }

  const LOGIN_SUCCESS_MESSAGE = 'Blurby Login Successful! This is a demo.';

  return (
    <div className="text-center mt-8">
      <h1>{LOGIN_SUCCESS_MESSAGE}</h1>
      <p>{`You have successfully logged in with JWT: ${accessTokenV2}`}</p>
    </div>
  );
};
